export enum ARENA_IDS {
    HOME = 'homeMenuItem',
    SLOTS = "slotsMenuItem",
    JACKPOTS = "jackpotsMenuItem",
    BLACKJACK = "blackjackMenuItem",
    ROULETTE = "rouletteMenuItem",
    CASINO_GAMES = "casinoMenuItem",
    LIVE_CASINO = "liveCasinoMenuItem",
    SCRATCH_CARDS = "scratchCardsMenuItem",
    EXCLUSIVE888 = "exclusive888arenaMenuItem",
    VIDEO_POKER = "videoPokerMenuItem",
    GAME_SHOWS = "gameShowsMenuItem",
    NEW_GAMES = "newGamesMenuItem"
}